module.exports = __webpack_public_path__ + "img/draw-title.2f3bc5e9.png";